var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKbvV16LiveStatHScore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 9",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0568182 9V0.272727H1.11364V4.15909H5.76705V0.272727H6.82386V9H5.76705V5.09659H1.11364V9H0.0568182ZM8.46236 1.21023V0.272727H15.0078V1.21023H12.2635V9H11.2067V1.21023H8.46236Z",
    fill: "#FFEB39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKbvV16LiveStatHScore);
export default __webpack_public_path__ + "static/media/kbv-v16-live-stat-h-score.e6e4a56869dd4b5dc5f41e848f041d76.svg";
export { ForwardRef as ReactComponent };